function getBaseUrl() {
  if (typeof window !== "undefined" && window.location) {
    // In local dev server (npm start on port 3000), point to local backend
    if (window.location.port === "3000") {
      return process.env.REACT_APP_BACK_END_URL || "http://localhost:8000";
    }
    // In production (served via Nginx on 80/443), use relative URL so Nginx handles /api
    return "";
  }
  return process.env.REACT_APP_BACK_END_URL || "";
}

export default getBaseUrl;


